import { useEffect, useRef, useState } from 'react'

export interface IArtworkWidget {
  className?: string
  position: {
    x: number
    y: number
  }
  size: {
    w: number
    h: number
  }
  rotation: number
  assetSvgData: string
  assetUrl?: string
  color?: string
  multiColorMode?: boolean
}

export function ArtworkWidget({
  position,
  size,
  rotation,
  assetSvgData,
  assetUrl,
  color,
  multiColorMode,
}: IArtworkWidget) {
  const widgetRef = useRef(null)
  const [svgData, setSvgData] = useState(assetSvgData)

  useEffect(() => {
    if (multiColorMode && assetUrl) {
      const image = widgetRef?.current
      if (image) {
        image.style.width = '100%'
        image.style.height = '100%'
        image.style.color = color
        image.setAttribute('width', size.w)
        image.setAttribute('height', size.h)
        image.setAttribute(
          'transform',
          `rotate(${rotation || 0} ${size.w / 2} ${size.h / 2})`
        )
      }
    } else {
      const group = widgetRef?.current
      const svg = group?.children[0]

      if (svg) {
        svg.style.fill = color
        svg.style.width = '100%'
        svg.style.height = '100%'
        svg.style.color = color
        svg.setAttribute('width', size.w)
        svg.setAttribute('height', size.h)

        const setFillOnChildren = (element: Element) => {
          if (
            [
              'path',
              'rect',
              'circle',
              'ellipse',
              'polygon',
              'polyline',
              'line',
            ].includes(element.tagName.toLowerCase())
          ) {
            element.setAttribute('fill', color || '')
          }

          Array.from(element.children).forEach((child) => {
            setFillOnChildren(child)
          })
        }

        setFillOnChildren(svg)

        group.setAttribute(
          'transform',
          `rotate(${rotation || 0} ${size.w / 2} ${size.h / 2})`
        )
        setSvgData(svg.outerHTML)
      }
    }
  }, [
    widgetRef,
    size,
    rotation,
    color,
    position,
    assetSvgData,
    multiColorMode,
    assetUrl,
  ])

  return (
    <svg
      key={position?.x + '__' + position?.y}
      id={position?.x + '__' + position?.y}
      x={position?.x || 0}
      y={position?.y || 0}
      width={Math.max(size?.w, 0)}
      height={Math.max(size?.h || 0)}
      style={{ overflow: 'visible' } as unknown}
    >
      {multiColorMode && assetUrl ? (
        <image
          xlinkHref={assetUrl}
          ref={widgetRef}
          preserveAspectRatio="xMinYMin meet"
        />
      ) : (
        <g dangerouslySetInnerHTML={{ __html: svgData }} ref={widgetRef} />
      )}
    </svg>
  )
}
